import React from "react";
import { Link } from "react-router-dom";
import { ContactNumbers } from "../ContactNumbers/ContactNumbers";

export const CtaAreaFive = () => {
  return (
    <section className="cta-area-five">
      <div className="container">
        <div
          className="cta-inner-wrap-two"
         
        >
          <div className="row align-items-center">
            <div className="col-lg-9">
              <div>
                <div className="cta-info-wrap">
                  <div className="icon">
                    <i className="flaticon-phone-call"></i>
                  </div>
                  <div className="content">
                    <span>Call For More Info</span>
                    <ContactNumbers
                      className="cta-contact-numbers"
                      includeWhatsApp={false}
                      showLabels={false}
                    />
                  </div>
                </div>
                <h2 className="title">
                  Book a Free Consultation and get guidance on the right service
                  for your business
                </h2>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="cta-btn text-end">
                <Link to="/contact" className="btn btn-three">
                  Contact Us
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
